import { UserType } from "../../../../../../shared/constants/user-type-enum";

export interface IFaq {
    faqId: string;
    questionEnglish: string;
    questionArabic: string;
    answerEnglish: string;
    answerArabic: string;
    userType: string;
    faqUserTypeDetails: IfaqUserTypeDetail[];
}

export const faqConfig = {
    entityName: 'ADMINISTRATOR.FAQ.TITLE',
    for: 'COMMON.FOR',
    questionEnglish: 'COMMON.QUESTION_ENGLISH',
    questionArabic: 'COMMON.QUESTION_ARABIC',
    answerEnglish: 'COMMON.ANSWER_ENGLISH',
    answerArabic: 'COMMON.ANSWER_ARABIC'
};

interface IfaqUserTypeDetail {
    userTypeName: string;
    userType: UserType;
}